// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  mentionId: __t.u64().primaryKey().name("mention_id"),
  messageId: __t.u64().name("message_id"),
  workspaceId: __t.u64().name("workspace_id"),
  targetAgentId: __t.u64().name("target_agent_id"),
  seatKey: __t.string().name("seat_key"),
  token: __t.string(),
  createdAt: __t.i64().name("created_at"),
});
